import FavouritesPage from './themes/default/FavouritesPage';

export default FavouritesPage;
